interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="flex h-10 items-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`h-10 w-10 rounded-md border text-sm transition-colors ${
            p === page
              ? 'border-primary-500 bg-primary-500 font-semibold text-background-50'
              : 'border-background-200 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-600'
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="flex h-10 items-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}